import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  getDoc
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function Unlock() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // 🔄 Watch for access change and redirect
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    let interval;

    const checkAccess = async () => {
      try {
        const docSnap = await getDoc(doc(db, "parents", user.uid));
        const data = docSnap.data();

        console.log("🔄 checking access:", data?.hasAccess);

        if (data?.hasAccess) {
          clearInterval(interval);
          navigate("/edit");
        }
      } catch (err) {
        console.error("Error checking access:", err);
      }
    };

    interval = setInterval(checkAccess, 500);

    return () => clearInterval(interval);
  }, [navigate]);

  const handleRedeem = async () => {
    const user = auth.currentUser;

    if (!user) {
      setError("You must be logged in");
      return;
    }

    // ✅ Start loading
    setError("");
    setIsLoading(true);

    // ⏱ Backup message if slow
    setTimeout(() => {
      setError("Still working... this can take a few seconds");
    }, 4000);

    try {
      const q = query(
        collection(db, "accessCodes"),
        where("code", "==", code.trim())
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setError("Invalid code");
        setIsLoading(false);
        return;
      }

      const codeDoc = snapshot.docs[0];
      const codeData = codeDoc.data();

      if (codeData.used) {
        setError("Code already used");
        setIsLoading(false);
        return;
      }

      // ✅ Mark code as used
      await updateDoc(codeDoc.ref, {
        used: true,
        usedBy: user.uid,
        usedAt: new Date()
      });

      // ✅ Unlock user
      await updateDoc(doc(db, "parents", user.uid), {
        hasAccess: true
      });

      console.log("✅ Unlock successful");

      // 🚫 DO NOT navigate here
      // useEffect handles redirect

    } catch (err) {
      console.error("❌ ERROR:", err);
      setError("Error redeeming code");
      setIsLoading(false);
    }
  };

  return (
    <div className="portal-page">
      <img
        src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
        alt="The Pink Collective logo"
        className="portal-logo"
      />

      <div className="portal-card">
        <h1 className="portal-title">Unlock Parent Portal</h1>
        <div className="portal-underline" />

        <p className="portal-text">
          Enter your access code to unlock editing.
        </p>

        <input
          className="portal-input"
          placeholder="Enter access code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          disabled={isLoading}
        />

        <button
          className="portal-button"
          onClick={handleRedeem}
          disabled={isLoading}
        >
          {isLoading ? "Unlocking..." : "Redeem Code"}
        </button>

        {/* 🔄 Loading message */}
        {isLoading && (
          <p className="portal-text" style={{ marginTop: "10px" }}>
            Preparing your parent portal... please do not close this page.
          </p>
        )}

        <p className="portal-text" style={{ marginTop: "20px" }}>
          Don’t have a code?
        </p>

        <button className="portal-button portal-button-secondary">
          Go to Shop
        </button>

        {error && (
          <p className="portal-message error-message">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}

export default Unlock;